import React, { memo, useEffect, useState } from 'react';
import { OverlayView, Polyline, useJsApiLoader } from '@react-google-maps/api';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { wsGetAll } from 'services/WService';

function GoogleMapCustom(props) {
  const { children, ...restProps } = props;

  const [distanceId, setDistanceId] = useState(1);
  const [distances, setDistances] = useState([]);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_API_KEY_GOOGLE,
    libraries: ['drawing'],
  });

  function onRightClick(e) {
    let point = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    setDistances((distances) => {
      let newDistances = [...distances];

      // Completar con el segundo punto
      if (newDistances.length > 0) {
        let index = newDistances.findIndex((distance) => distance.toPoint === undefined);
        if (index !== -1) {
          newDistances[index].toPoint = point;
          return newDistances;
        }
      }

      newDistances[newDistances.length] = { id: distanceId, fromPoint: point };
      setDistanceId((id) => id + 1);
      return newDistances;
    });
  }

  if (!isLoaded) return <span>Cargando...</span>;

  return (
    <GoogleMap {...restProps} onRightClick={onRightClick}>
      {distances.map((distance) => {
        return (
          <DistanceMarkers
            key={distance.id}
            distanceId={distance.id}
            toPoint={distance.toPoint}
            fromPoint={distance.fromPoint}
            setDistances={setDistances}
          />
        );
      })}
      {children}
    </GoogleMap>
  );
}

const DistanceMarkers = memo((props) => {
  const { fromPoint, toPoint } = props;
  const { distanceId, setDistances } = props;
  const [distanceData, setDistanceData] = useState();

  function onDragEnd(e, type = 'from') {
    let newPoint = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    setDistances((distances) => {
      let newDistances = [...distances];
      let index = newDistances.findIndex((item) => item.id === distanceId);
      if (index !== -1) {
        if (type === 'from') {
          newDistances[index].fromPoint = newPoint;
        } else {
          newDistances[index].toPoint = newPoint;
        }
      }
      return newDistances;
    });
  }

  function onDblClick() {
    let confirm = window.confirm('Eliminar esta distancia?');
    if (confirm) {
      setDistances((distances) => {
        let newDistances = [...distances];
        let index = newDistances.findIndex((item) => item.id === distanceId);
        if (index !== -1) {
          newDistances.splice(index, 1);
        }
        return newDistances;
      });
    }
  }

  async function getLineStringData() {
    setDistanceData(undefined);
    let fromPointQuery = `fromPoint[lng]=${fromPoint.lng}&fromPoint[lat]=${fromPoint.lat}`;
    let toPointQuery = `toPoint[lng]=${toPoint.lng}&toPoint[lat]=${toPoint.lat}`;
    let res = await wsGetAll(`/v3/geo/line-string-data?${fromPointQuery}&${toPointQuery}`);
    if (res.success) setDistanceData(res.data);
  }

  useEffect(() => {
    if (toPoint === undefined) return;
    getLineStringData();
  }, [fromPoint, toPoint]);

  return (
    <>
      {/* Marcador inicial */}
      <Marker
        position={fromPoint}
        draggable
        onDragEnd={(e) => onDragEnd(e, 'from')}
        onDblClick={onDblClick}
      />
      {/* Marcador final */}
      {toPoint !== undefined && (
        <Marker
          position={toPoint}
          draggable
          onDragEnd={(e) => onDragEnd(e, 'to')}
          onDblClick={onDblClick}
        />
      )}
      {/* Line */}
      {toPoint !== undefined && <Polyline path={[fromPoint, toPoint]} />}
      {/* Texto distancia */}
      {distanceData !== undefined && (
        <OverlayView
          position={{ lat: distanceData.centroid.lat, lng: distanceData.centroid.lng }}
          mapPaneName="floatPane"
          getPixelPositionOffset={() => ({ x: 0, y: 0 })}
        >
          <span
            style={{
              color: 'white',
              fontSize: '20px',
              textShadow: '-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black',
            }}
          >
            {distanceData.distance}m
          </span>
        </OverlayView>
      )}
    </>
  );
});

export default GoogleMapCustom;
